import axios, { AxiosError } from "axios";
const FeatureResource = {
    create(request, resultFunc, errorFunc, finallyFunc) {
        axios.post("/admin/v1/features", request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    update(featureId, request, resultFunc, errorFunc, finallyFunc) {
        axios.put(`/admin/v1/features/${featureId}`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    search(searchParams, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/features/`, {
            params: searchParams
        })
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
};
export default FeatureResource;
